import type { components } from '@trackercop/contracts';

type ConsentMode = components['schemas']['ConsentMode'];
type ScriptCategory = components['schemas']['ScriptCategory'];
type CookieCategory = components['schemas']['CookieCategory'];
type PayloadCategory = components['schemas']['PayloadCategory'];
type ClassificationSource = components['schemas']['ClassificationSource'];
type CmpProvider = components['schemas']['CmpProvider'];

export const CONSENT_MODES: ReadonlyArray<{ value: ConsentMode; label: string }> = [
  { value: 'no-consent', label: 'No consent' },
  { value: 'accept-all', label: 'Accept all' },
  { value: 'reject-all', label: 'Reject all' },
];

export const SCRIPT_CATEGORIES: readonly ScriptCategory[] = [
  'advertising',
  'marketing',
  'analytics',
  'social',
  'customer-data-platform',
  'session-replay',
  'ab-testing',
  'consent-management',
  'tag-manager',
  'cdn',
  'unknown',
];

export const COOKIE_CATEGORIES: readonly CookieCategory[] = [
  'strictly-necessary',
  'functional',
  'analytics',
  'advertising',
  'marketing',
  'social',
  'cdn',
  'unknown',
];

export const PAYLOAD_CATEGORIES: readonly PayloadCategory[] = [
  'pii',
  'identifier',
  'device-fingerprint',
  'behavioral',
  'advertising',
  'product',
  'benign',
];

export const CLASSIFICATION_SOURCES: readonly ClassificationSource[] = [
  'known-trackers',
  'tracker-radar',
  'easyprivacy',
  'easylist',
  'unknown',
];

export const CMP_PROVIDERS: readonly CmpProvider[] = [
  'onetrust',
  'cookiepro',
  'cookiebot',
  'trustarc',
  'osano',
  'usercentrics',
  'quantcast',
  'unknown',
];
